import { useNotify, useTranslate } from "ra-core";
import { useEffect, useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { useDialerApi } from "../dialer/api/DialerApiContext";

const K = "gavion.notifications.digest";

/**
 * GAVION X4: the rep's daily digest switch (Profil). Stored in sales.prefs.digest_enabled through
 * set_my_digest_enabled; absent means on. The digest itself is sent by the gavion-digest edge function.
 */
export const DigestPrefCard = () => {
  const api = useDialerApi();
  const t = useTranslate();
  const notify = useNotify();
  const [enabled, setEnabled] = useState<boolean | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let live = true;
    api.getMyPrefs().then(
      (p) => live && setEnabled(p.digest_enabled !== false),
      () => live && setEnabled(true),
    );
    return () => {
      live = false;
    };
  }, [api]);

  const onChange = async (next: boolean) => {
    const previous = enabled;
    setEnabled(next);
    setBusy(true);
    try {
      const prefs = await api.setMyDigestEnabled(next);
      setEnabled(prefs.digest_enabled !== false);
      notify(`${K}.${next ? "on" : "off"}`, { type: "success" });
    } catch {
      setEnabled(previous);
      notify(`${K}.error`, { type: "error" });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Card>
      <CardContent className="space-y-3">
        <h2 className="text-xl font-semibold text-muted-foreground">
          {t(`${K}.title`)}
        </h2>
        <p className="text-sm text-muted-foreground">{t(`${K}.description`)}</p>
        <div className="flex min-h-11 items-center gap-3">
          <Switch
            id="gavion-digest-enabled"
            checked={enabled === true}
            disabled={enabled === null || busy}
            onCheckedChange={onChange}
          />
          <Label htmlFor="gavion-digest-enabled">{t(`${K}.toggle`)}</Label>
        </div>
      </CardContent>
    </Card>
  );
};
